import styled from 'styled-components';
import { theme, palette } from 'styled-tools';
import { FaInfoCircle } from 'react-icons/fa';

export const Container = styled.div`
  background-color: ${palette('bannerInfoBackgroundColor')};
  padding: 12px;
  margin-bottom: 10px;
  border-radius: ${theme('borderRadius.md')};
  border: 1px solid ${palette('bannerInfoBorderColor')};
  display: flex;
  gap: 12px;

  h1 {
    color: ${palette('bannerInfoBorderColor')};
    font-size: ${theme('fontSize.sm')};
    font-weight: bold;
    margin-bottom: 6px;
  }
`;

export const InfoIcon = styled(FaInfoCircle)`
  color: ${palette('bannerInfoBorderColor')};
  width: 18px;
  height: 18px;
`;
